import { css } from "styled-components";
import token from "styled-token";
import { spacingMixin } from "../spacingMixin";
import { disabledMixin } from "../disabledMixin";
import { radioStateMixin } from "../radioStateMixin";

var offscreenCSS = function offscreenCSS(_ref) {
  var offscreen = _ref.offscreen;

  if (!offscreen) {
    return "";
  }

  return "\n        && {\n            position: absolute;\n            left: -99999px;\n        }\n    ";
};

var zsgCSS = token({
  borderColor: "Radio.borderColor",
  borderColorDisabled: "Radio.borderColorDisabled",
  borderColorInteractive: "Input.borderColorInteractive",
  borderWidth: "Radio.borderWidth",
  borderWidthChecked: "Radio.borderWidthChecked",
  fontColorLabel: "colors.textDark",
  size: "Radio.size"
}, function (_ref2) {
  var borderColor = _ref2.borderColor,
      borderColorDisabled = _ref2.borderColorDisabled,
      borderColorInteractive = _ref2.borderColorInteractive,
      borderWidth = _ref2.borderWidth,
      borderWidthChecked = _ref2.borderWidthChecked,
      fontColorLabel = _ref2.fontColorLabel,
      size = _ref2.size;
  return css(["input&{position:static;height:", "px;width:", "px;}input&,input&:hover,input&:active,input&:focus{border:", "px solid ", ";&:checked{border-color:", ";border-width:", "px;}&:disabled:not(:checked){border-color:", ";}}input& + label{padding-left:0;&:hover{color:", ";}}input& + label:before,input&:checked + label:after{content:none;}"], size, size, borderWidth, borderColor, borderColorInteractive, borderWidthChecked, borderColorDisabled, fontColorLabel);
});
/** @class RadioMixin */

/** @method */

export var RadioMixin = function RadioMixin(props) {
  return css(["", " ", " &:hover:not(:disabled){", "}&:checked{", "}&:focus{", "}&:disabled{", "}", " ", ""], zsgCSS(props), radioStateMixin()(props), radioStateMixin("hover")(props), radioStateMixin("checked")(props), radioStateMixin("focus")(props), disabledMixin(Object.assign({}, props, {
    disabled: true
  })), offscreenCSS(props), spacingMixin(props));
};